import actions from '../../actions';
import BackButton from './back-button';
import {CollaborateButton, CollaboratorDisplay} from '../../collaborate';
import edap from '../../edap';
import EditButton from './edit-button';
import EditName from './edit-name';
import React, {Component} from 'react';
import RolePermissions from '../../../components/permissions';
import {ROLES} from '../../../utils/constants';
import withRenameTripboard from './with-rename-tripboard';

export const initialState = {
    isEditing: false,
    isNameChanged: false,
    isSaveable: false
};

export class EditHeader extends Component {
    static defaultProps = {
        boardId: null,
        collaboratorType: '',
        name: '',
        rename: () => {},
        role: ROLES.VIEWER
    }

    constructor(props) {
        super(props);

        this.state = {
            ...initialState,
            nameEdit: props.name
        };
    }

    // Currently, we are only enabling Save (Done button) if the name
    // has changed. In the future, if the user can edit additional information
    // that is tied to the Save (or Done button), then we can include that
    // logic here.
    isSaveable = (state) => {
        return state.isNameChanged;
    }

    onCancel = () => {
        const {boardId} = this.props;
        edap.editCancel(boardId);
        this.reset();
    }

    onDone = () => {
        const {isSaveable, nameEdit} = this.state;
        const {boardId, name, rename, role} = this.props;
        const newName = nameEdit.trim();

        if (!isSaveable) {
            return;
        }

        rename(boardId, newName);
        edap.editAttempt(boardId, name, newName, role);
        edap.editDone(boardId);
        this.reset();
    }

    onEdit = () => {
        const {boardId} = this.props;
        const {isEditing} = this.state;
        edap.editStart(boardId);
        this.setState({
            isEditing: !isEditing
        });
    }

    onNameChange = (state) => {
        const {isNameChanged, name} = state;
        const newState = {
            ...this.state,
            isNameChanged,
            nameEdit: name
        };
        this.setState({
            isNameChanged,
            isSaveable: this.isSaveable(newState),
            nameEdit: name
        });
    }

    reset = () => {
        const {name} = this.props;
        this.setState({
            ...initialState,
            nameEdit: name
        });
    }

    render() {
        const {boardId, collaboratorType, name, role, startDate, endDate, users, showEmptyStateSearch} = this.props;
        const {isEditing, isSaveable} = this.state;
        const {onCancel, onDone, onEdit, onNameChange} = this;
        return (
            <React.Fragment>
                <div className="flex-row flex-space-between padding-bottom-3x">
                    <div>
                        <RolePermissions role={role} collaborator owner>
                            <BackButton />
                        </RolePermissions>
                    </div>
                    <div>
                        <RolePermissions role={role} collaborator owner>
                            <EditButton
                                boardId={boardId}
                                isEditing={isEditing}
                                isSaveable={isSaveable}
                                onCancel={onCancel}
                                onDone={onDone}
                                onEdit={onEdit}
                            />
                        </RolePermissions>
                    </div>
                </div>
                <div className="row">
                    {isEditing &&
                        <div className="col-xs-12 col-sm-6 col-md-4 col-xlg-3">
                            <EditName
                                boardId={boardId}
                                name={name}
                                onDone={onDone}
                                onNameChange={onNameChange}
                            />
                        </div>
                    }
                    {!isEditing &&
                        <div>
                            <div className="col-xs-12">
                                <div className="flex-row flex-space-between flex-align-items-center flex-wrap margin-bottom-2x ">
                                    <h2
                                        className="trip-board-details__header-title"
                                        data-wdio="tripboard-details__title"
                                    >
                                        {name}
                                    </h2>
                                    {/* Show Share/Invite button in place of edit button if VIEWER */}
                                    <RolePermissions role={role} viewer>
                                        <div className="flex-align-center flex-align-items-center flex-end flex-row padding-top-1x">
                                            <div className="view-button">
                                                <CollaborateButton boardId={boardId} />
                                            </div>
                                        </div>
                                    </RolePermissions>
                                    {showEmptyStateSearch &&
                                        <RolePermissions role={role} collaborator owner>
                                            <div className="flex-align-center flex-align-items-center flex-end flex-row">
                                                <CollaboratorDisplay users={users}/>
                                                <CollaborateButton
                                                    boardId={boardId}
                                                    endDate={endDate}
                                                    startDate={startDate}
                                                    type={collaboratorType}
                                                />
                                            </div>
                                        </RolePermissions>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </React.Fragment>
        );
    }
}

// Redux wrapper
export const mapDispatchToProps = {
    rename: actions.renameTripboard
};

// Graphql wrapper
const EditHeaderWithGraphql = withRenameTripboard(EditHeader);

// toggle will switch between redux / graphql as our source of truth
export default EditHeaderWithGraphql;



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/header-with-edit-state.js